module.exports = __webpack_public_path__ + "static/assets/0d242b6563db3d5c7851c1b71c7af6aa.svg";